const { event } = require("jquery")

// 動作していない　ここから
$(document).on ('ajax:error', '#statement_item_form', (event) => {
  console.log('error!')
  data = event.detail[0], http_status = event.detail[1], xhr = event.detail[2]
  form = $('#statement_item_form')
  alert = '<div id="statement-item-error" class="alert alert-danger alert-dismissable" role="alert">'
  alert = alert + '<button class="btn-close" type="button" data-bs-dismiss="alert" aria-label="Close"></button>'
  $.each(data.errors, (idx, msg) => {
    alert = alert + `<strong>・${msg}</strong><br>`
  })
  alert = alert + '</div>'

  if ($('#statement-item-error')[0]) {
    $('#statement-item-error').remove()
    form.prepend(alert)
  } else {
    form.prepend(alert)
  }
})
// 動作していない　ここまで

$(document).on('change', '#key-type-selector', () => {
  key_type = $('#key-type-selector').find('option:selected').val()

  if (key_type == 'any') {
    displayKeyInputForm()
  } else {
    hideKeyInputForm()
  }
});

function displayKeyInputForm () {
  $('.key-input-form').val('')
  $('.key-input-form').prop('disabled', false)
  $('.key-input-form-area').css('display', 'block')
}

function hideKeyInputForm () {
  $('.key-input-form').val('')
  $('.key-input-form').prop('disabled', true)
  $('.key-input-form-area').hide()
}
